"use client";

import { useId } from "react";

interface GradientCornerBorderProps {
  width?: number;
  height?: number;
  borderRadius?: number;
  className?: string;
}

export function GradientCornerBorder({
  width = 100,
  height = 100,
  borderRadius = 16,
  className = "",
}: GradientCornerBorderProps) {
  const gradientId = useId();
  const r = borderRadius;
  const strokeWidth = 1;
  const offset = strokeWidth / 2;

  return (
    <div
      className={`absolute top-0 left-0 pointer-events-none ${className}`}
      style={{ width, height }}
    >
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d={`M ${width} ${offset} H ${r} A ${r - offset} ${
            r - offset
          } 0 0 0 ${offset} ${r} V ${height}`}
          stroke={`url(#${gradientId})`}
          strokeWidth={strokeWidth}
        />
        <defs>
          <radialGradient
            id={gradientId}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#FFEFFF" />
            <stop offset="0.25" stopColor="#F5AAFE" />
            <stop offset="0.5" stopColor="#5C63EE" />
            <stop offset="1" stopColor="#11111100" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
}
